import {IExerciseDialogue} from './interfaces';
import {IAction} from '../interface';
import {InferActionsTypes} from '../helpers';

export const SET_EXERCISE_TO_DO = 'SET_EXERCISE_TO_DO';
export const setExerciseToDo = (dialogues: IExerciseDialogue[]): IAction<IExerciseDialogue[]> => ({
  type: SET_EXERCISE_TO_DO,
  payload: dialogues
});
export const SET_EXERCISE_DONE = 'SET_EXERCISE_DONE';
export const setExerciseDone = (dialogues: IExerciseDialogue[]): IAction<IExerciseDialogue[]> => ({
  type: SET_EXERCISE_DONE,
  payload: dialogues
});

export const SET_EXERCISE_DIALOGUE = 'SET_EXERCISE_DIALOGUE';
export const setExerciseDialogue = (dialogue: IExerciseDialogue): IAction<IExerciseDialogue> => ({
  type: SET_EXERCISE_DIALOGUE,
  payload: dialogue
});

export const CLEAR_EXERCISE_DIALOGUE = 'CLEAR_EXERCISE_DIALOGUE';
export const clearExerciseDialogue = (): IAction<null> => ({
  type: CLEAR_EXERCISE_DIALOGUE,
  payload: null
});

export const SET_EXERCISE_STATISTICS = 'SET_EXERCISE_STATISTICS';
export const setExerciseStatistics = (statistics: string[]): IAction<string[]> => ({
  type: SET_EXERCISE_STATISTICS,
  payload: statistics
});

const exerciseActions = {
  setExerciseToDo,
  setExerciseDone,
  setExerciseDialogue,
  clearExerciseDialogue,
  setExerciseStatistics
};

export type ExerciseActionsType = InferActionsTypes<typeof exerciseActions>;
